import { PauseIcon, PlayIcon } from '@radix-ui/react-icons';
import { IconButton, IconButtonProps } from '@radix-ui/themes';
import { useMediaRemote, useMediaState } from '@vidstack/react';
import { useTranslation } from 'react-i18next';

export const SmartPlayerPlayPause = (props: IconButtonProps) => {
    const { t } = useTranslation('smartPlayer');
    const isPaused = useMediaState('paused');
    const remote = useMediaRemote();

    const handleToggle = (e: React.MouseEvent) => {
        e.stopPropagation();

        if (isPaused) {
            remote.changePlaybackRate(1);
            remote.play();
        } else {
            remote.pause();
        }
    };

    return (
        <IconButton
            size='3'
            variant='soft'
            color='gray'
            highContrast
            onClick={handleToggle}
            style={{ cursor: 'pointer', pointerEvents: 'auto' }}
            title={isPaused ? t('controls.play') : t('controls.pause')}
            {...props}
        >
            {isPaused ? (
                <PlayIcon width='20' height='20' />
            ) : (
                <PauseIcon width='20' height='20' />
            )}
        </IconButton>
    );
};
